import { createFileRoute } from "@tanstack/react-router";
import { marketingHead } from "../marketing-content/head";
import { MarketingQaUseCasePage } from "../components/marketing/MarketingQaUseCasePage";

export const Route = createFileRoute("/use-cases/qa")({
  head: () => marketingHead("/use-cases/qa"),
  component: MarketingQaUseCasePage,
});
